<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row 
                class="my-2 subtitle-2 secondary--text pl-12">
                Segments & consumers' values
            </v-row>
            <!--table head-->
            <v-divider />
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <div v-if="market_segments.length">
                <!--segments tab-->
                <v-row v-for="segment in market_segments" :key="segment.id" no-gutters>
                    <v-col class="tabCell text-left text-truncate">{{ segment.segment.name }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.family }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.attractiveness }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.personality }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.social_status }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.fun }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.friendship }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.pets }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.independent }}</v-col>
                </v-row>
            </div>
        </div>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
//import  AddValue from '../../components/admin/addValue.vue'
//import deleteSegment from './modal/deleteSegment.vue'
import Loader from '../../../layouts/Loader.vue'

export default {
    name: 'AdminValue',
    data() {
        return {
            headers: [
                {title: 'Segment', style: 'text-left'},
                { title: 'Family / kids', style: 'text-center' },
                { title: 'Personal attractiveness', style: 'text-center' },
                { title: 'Strong personality', style: 'text-center' },
                { title: 'Social status', style: 'text-center' },
                { title: 'Fun', style: 'text-center' },
                { title: 'Friendship', style: 'text-center' },
                { title: 'Pets', style: 'text-center' },
                { title: 'Independent style', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        market_segments() {
            return this.$store.getters.market_segments
        }
    },
    methods: {},
    components: {
        Loader
    }
}
</script>